<template>
  <footer class="footer section">
    <div class="container">
      <div class="row">
        <div class="col">
          <p class="copyright">
            {{ $t('copyright') }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
            <p class="legal">
              <a href="https://skeargames.com/terms_and_conditions_of_use/">{{ $t('legal_disclaimer') }} </a> | <a href="https://skeargames.com/privacy_policy/">{{ $t('privacy_policy') }}</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer{
  padding-top: 200px;
  background-image: url(../assets/background/planeteSurfaceSciFiSmallSize.jpg);
  background-size: cover;
  background-position: top;
  text-align: center;
  font-size: 12px;
  .copyright{
    margin-top: 0;
    margin-bottom: 1rem;
  }
  .legal{
    margin-top: 0;
    margin-bottom: 1rem;
    a{
        color: white;
    }
  }
}
</style>
